import { jsx, jsxs } from "react/jsx-runtime";
//#region src/Passkey.tsx
function SvgPasskey(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18.5 9.5q1.45 0 2.475 1.025A3.37 3.37 0 0 1 22 13a3.3 3.3 0 0 1-.638 2q-.637.875-1.612 1.25v3.25h1.225v2H17.5v-5.15a3.45 3.45 0 0 1-1.8-1.238Q15 14.2 15 13q0-1.45 1.025-2.475A3.37 3.37 0 0 1 18.5 9.5m0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11 12.5a13.4 13.4 0 0 1 2 .15q-.1 1.45.525 2.738A5.4 5.4 0 0 0 15.35 17.5v2H3v-2.8q0-.85.438-1.562A2.9 2.9 0 0 1 4.6 14.05a15 15 0 0 1 3.15-1.162A13.8 13.8 0 0 1 11 12.5m0-9q1.65 0 2.825 1.175T15 7.5c-.001 1.65-.392 2.042-1.175 2.825Q12.65 11.501 11 11.5c-1.65-.001-2.042-.392-2.825-1.175Q6.999 9.15 7 7.5c.001-1.65.391-2.042 1.175-2.825Q9.35 3.499 11 3.5"
		})]
	});
}
//#endregion
//#region src/Activity.tsx
function SvgActivity(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M16.811 10.584a1 1 0 1 0-1.623-1.168l-1.852 2.573-1.694-1.059a2 2 0 0 0-2.547.358l-1.838 2.043a1 1 0 0 0 1.486 1.338l1.839-2.043 1.694 1.059a2 2 0 0 0 2.683-.527z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3 9a6 6 0 0 1 6-6h6a6 6 0 0 1 6 6v6a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6zm16 0v6a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/Add.tsx
function SvgAdd(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
		})
	});
}
//#endregion
//#region src/Apps.tsx
function SvgApps(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm4 2H5v4h4z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17 3a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0V8h-2a1 1 0 1 1 0-2h2V4a1 1 0 0 1 1-1"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5 13a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm4 2H5v4h4zm4 0a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm2 4v-4h4v4z",
				clipRule: "evenodd"
			})
		]
	});
}
//#endregion
//#region src/ArrowBack.tsx
function SvgArrowBack(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4 12.004a1 1 0 0 0 .293.703l6 6a1 1 0 0 0 1.414-1.414L7.414 13H19a1 1 0 1 0 0-2H7.414l4.293-4.293a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0-.293.705z"
		})
	});
}
//#endregion
//#region src/ArrowBottomLeft.tsx
function SvgArrowBottomLeft(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M6.296 17.488a1 1 0 0 0 .704.29h8.071a1 1 0 1 0 0-2H9.414l8.071-8.07a1 1 0 0 0-1.414-1.415L8 14.364V8.707a1 1 0 1 0-2 0v8.07a1 1 0 0 0 .291.706l.002.002z"
		})
	});
}
//#endregion
//#region src/ArrowDown.tsx
function SvgArrowDown(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11.45 15.335a1 1 0 0 0 1.257-.128l5-5a1 1 0 0 0-1.414-1.414L12 13.086 7.707 8.793a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 .157.128"
		})
	});
}
//#endregion
//#region src/ArrowForward.tsx
function SvgArrowForward(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M20 12.004a1 1 0 0 1-.293.703l-6 6a1 1 0 0 1-1.414-1.414L16.586 13H5a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 1.414-1.414l6 6a1 1 0 0 1 .293.705z"
		})
	});
}
//#endregion
//#region src/ArrowLeft.tsx
function SvgArrowLeft(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L10.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
		})
	});
}
//#endregion
//#region src/ArrowRight.tsx
function SvgArrowRight(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m10.707 6.293 5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L13.586 12 9.293 7.707a1 1 0 0 1 1.414-1.414"
		})
	});
}
//#endregion
//#region src/ArrowTopRight.tsx
function SvgArrowTopRight(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.483 6.29a1 1 0 0 0-.705-.29h-8.07a1 1 0 1 0 0 2h5.656l-8.071 8.071a1 1 0 1 0 1.414 1.414l8.071-8.07v5.656a1 1 0 1 0 2 0v-8.07a1 1 0 0 0-.291-.706l-.002-.002z"
		})
	});
}
//#endregion
//#region src/ArrowUp.tsx
function SvgArrowUp(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m6.293 13.793 5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L12 10.914l-4.293 4.293a1 1 0 0 1-1.414-1.414"
		})
	});
}
//#endregion
//#region src/Assets.tsx
function SvgAssets(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7 3a5 5 0 0 0-5 5v6a5 5 0 0 0 5 5c1.038 0 1.63.263 2.605.524l5.795 1.553a5 5 0 0 0 6.124-3.536l1.553-5.795a5 5 0 0 0-3.536-6.124l-2.597-.696A5 5 0 0 0 13 3zm10.989 4.659a5 5 0 0 0-.043-.394l1.078.289a3 3 0 0 1 2.121 3.674l-1.553 5.796a3 3 0 0 1-3.674 2.121l-1.408-.377a5 5 0 0 0 2.916-2.44A5 5 0 0 0 18 14V8q0-.172-.011-.341m-2.54 8.074c.347-.49.551-1.087.551-1.733V8a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v6a3 3 0 0 0 2.984 3H13c1.011 0 1.906-.5 2.45-1.267Z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Calendar.tsx
function SvgCalendar(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14 14a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1M5 17V8h14v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/Checkmark.tsx
function SvgCheckmark(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m10.26 13.845 5.95-5.95a.994.994 0 0 1 1.405-.008.994.994 0 0 1-.008 1.406L10.95 15.95a.994.994 0 0 1-1.406.008l-2.846-2.845a.994.994 0 0 1 .01-1.406.994.994 0 0 1 1.405-.009z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/CheckmarkFilled.tsx
function SvgCheckmarkFilled(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.21-14.104-5.95 5.95-2.147-2.148a.994.994 0 0 0-1.406.009.994.994 0 0 0-.009 1.405l2.846 2.846a.994.994 0 0 0 1.406-.008l6.657-6.657a.994.994 0 0 0 .008-1.406.994.994 0 0 0-1.405.009",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/CircleEmitter.tsx
function SvgCircleEmitter(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4.609 8.938a8 8 0 0 0 1.734 8.719L4.93 19.07a10 10 0 0 1 0-14.142l1.414 1.414A8 8 0 0 0 4.61 8.938ZM20 12a8 8 0 0 0-2.343-5.657l1.414-1.414a10 10 0 0 1 0 14.142l-1.414-1.414A8 8 0 0 0 20 12"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/Clock.tsx
function SvgClock(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-12a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2.828 2.829a1 1 0 1 0 1.415-1.415L13 11.586z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Close.tsx
function SvgClose(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.415L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.294a1 1 0 0 0 1.414-1.415L13.414 12z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/CloseFilled.tsx
function SvgCloseFilled(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m4.242 5.757a1 1 0 0 0-1.414 0L12 10.586l-2.829-2.83a1 1 0 0 0-1.414 1.416L10.585 12l-2.828 2.828a1 1 0 0 0 1.414 1.414l2.83-2.828 2.827 2.828a1 1 0 1 0 1.414-1.414L13.414 12l2.828-2.828a1 1 0 0 0 0-1.415",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Coin.tsx
function SvgCoin(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 4c5.523 0 10 2.239 10 5v4.999c0 2.761-4.477 5-10 5s-10-2.239-10-5V9c0-2.761 4.477-5 10-5M7 16.232c1.122.385 2.485.655 4 .739v-2.998a17.6 17.6 0 0 1-4-.644zm10-2.903a17.6 17.6 0 0 1-4 .644v2.998c1.515-.084 2.878-.354 4-.739zM4 14c0 .17.143.667 1 1.264v-2.697A9 9 0 0 1 4 12zm16-2c-.304.202-.64.39-1 .567v2.697c.857-.597 1-1.093 1-1.264zM12 6c-2.518 0-4.7.514-6.177 1.253C4.226 8.05 4 8.785 4 9s.226.949 1.823 1.747C7.301 11.486 9.482 12 12 12s4.7-.514 6.177-1.253C19.774 9.95 20 9.215 20 9s-.226-.949-1.823-1.747C16.699 6.514 14.518 6 12 6",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Copy.tsx
function SvgCopy(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-1H6a3 3 0 0 1-3-3zm6 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1zm6-11h-5a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Create.tsx
function SvgCreate(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/DarkMode.tsx
function SvgDarkMode(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.22 6.05a6.001 6.001 0 1 0 4.317 10.797A7.003 7.003 0 0 1 11.22 6.05M4 12a8 8 0 0 1 8-8c.796 0 1.323.54 1.502 1.122a1.81 1.81 0 0 1-.343 1.677A5 5 0 0 0 17 15a1.39 1.39 0 0 1 1.215.717c.237.43.253 1.034-.155 1.506A8 8 0 0 1 4 12",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Dash.tsx
function SvgDash(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("rect", {
			width: 10,
			height: 2,
			x: 7,
			y: 11,
			fill: "currentColor",
			rx: 1
		})
	});
}
//#endregion
//#region src/DataStack.tsx
function SvgDataStack(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5 14v2c0 1.657 3.134 3 7 3s7-1.343 7-3v-2c0 1.657-3.134 3-7 3s-7-1.343-7-3"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5 10v2c0 1.657 3.134 3 7 3s7-1.343 7-3v-2c0 1.657-3.134 3-7 3s-7-1.343-7-3"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19 8c0 1.657-3.134 3-7 3S5 9.657 5 8s3.134-3 7-3 7 1.343 7 3"
			})
		]
	});
}
//#endregion
//#region src/Delete.tsx
function SvgDelete(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-.069l-.8 11.214A3 3 0 0 1 16.137 22H7.862a3 3 0 0 1-2.992-2.786L4.069 8H4a1 1 0 0 1 0-2h4zM6.074 8l.79 11.071a1 1 0 0 0 .998.929h8.276a1 1 0 0 0 .997-.929L17.926 8zM14 6h-4V4h4zm-4 4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Disconnect.tsx
function SvgDisconnect(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m12 19.071 1.828-1.828-1.414-1.414-1.828 1.828q-.885.885-2.122.884a2.9 2.9 0 0 1-2.12-.884 2.9 2.9 0 0 1-.885-2.121q0-1.237.884-2.122l1.829-1.828-1.415-1.414L4.93 12q-1.467 1.467-1.467 3.536c0 2.069.489 2.557 1.467 3.535q1.467 1.467 3.535 1.467 2.07 0 3.536-1.467Zm3.828-6.657 1.415 1.415L19.07 12q1.467-1.467 1.467-3.535 0-2.07-1.467-3.536t-3.536-1.467q-2.068 0-3.535 1.467l-1.828 1.829 1.414 1.414 1.828-1.829a2.9 2.9 0 0 1 2.122-.884 2.9 2.9 0 0 1 2.12.884q.885.885.885 2.122c0 1.237-.295 1.532-.884 2.121zM4.293 5.707l14 14 1.414-1.414-14-14z"
		})
	});
}
//#endregion
//#region src/Discord.tsx
function SvgDiscord(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5.058 5.34A16 16 0 0 1 9.184 4c.178.332.386.779.529 1.134a14.7 14.7 0 0 1 4.573 0c.143-.355.355-.802.534-1.134 1.45.26 2.835.716 4.13 1.343 2.611 4.078 3.319 8.055 2.965 11.975-1.732 1.337-3.41 2.149-5.06 2.68a13 13 0 0 1-1.084-1.844 10.5 10.5 0 0 0 1.706-.859 9 9 0 0 1-.418-.342c-3.29 1.59-6.866 1.59-10.118 0q-.206.178-.418.342c.54.337 1.113.626 1.71.86A13 13 0 0 1 7.149 20c-1.652-.531-3.332-1.343-5.064-2.682-.415-4.544.71-8.484 2.973-11.978m10.264 9.568c.988 0 1.798-.954 1.798-2.114s-.793-2.116-1.798-2.116-1.815.953-1.798 2.116c-.001 1.16.793 2.114 1.798 2.114m-6.644 0c.988 0 1.798-.954 1.798-2.114s-.793-2.116-1.798-2.116-1.816.953-1.798 2.116c0 1.16.793 2.114 1.798 2.114"
		})
	});
}
//#endregion
//#region src/DoubleArrowLeft.tsx
function SvgDoubleArrowLeft(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L7.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
		})]
	});
}
//#endregion
//#region src/DoubleArrowRight.tsx
function SvgDoubleArrowRight(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11.835 11.45a1 1 0 0 1-.128 1.257l-5 5a1 1 0 0 1-1.414-1.414L9.586 12 5.293 7.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 .128.157"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.835 11.45a1 1 0 0 1-.128 1.257l-5 5a1 1 0 0 1-1.414-1.414L15.586 12l-4.293-4.293a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 .128.157"
		})]
	});
}
//#endregion
//#region src/Edit.tsx
function SvgEdit(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.561 4.439a1.503 1.503 0 0 0-2.122 0l-.791.789 2.12 2.116.793-.792a1.49 1.49 0 0 0 0-2.113m1.413 3.528a3.49 3.49 0 0 0 0-4.944 3.503 3.503 0 0 0-4.948 0l-1.5 1.497-.002.001L2 17.021V22h4.914zm-3.622.79-2.12-2.116L4 17.85V20h2.086z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Exclamation.tsx
function SvgExclamation(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-3.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m-1.2-9.6a1.2 1.2 0 0 1 2.4 0v3.6a1.2 1.2 0 0 1-2.4 0z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Expand.tsx
function SvgExpand(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4 2a2 2 0 0 0-2 2v4a1 1 0 1 0 2 0V5.414l3.293 3.293a1 1 0 0 0 1.414-1.414L5.414 4H8a1 1 0 0 0 0-2zm18 2a2 2 0 0 0-2-2h-4a1 1 0 1 0 0 2h2.586l-3.293 3.293a1 1 0 0 0 1.414 1.414L20 5.414V8a1 1 0 1 0 2 0zM2 20a2 2 0 0 0 2 2h4a1 1 0 1 0 0-2H5.414l3.293-3.293a1 1 0 1 0-1.414-1.414L4 18.586V16a1 1 0 1 0-2 0zm20 0a2 2 0 0 1-2 2h-4a1 1 0 1 1 0-2h2.586l-3.293-3.293a1 1 0 0 1 1.414-1.414L20 18.586V16a1 1 0 1 1 2 0z"
		})
	});
}
//#endregion
//#region src/Export.tsx
function SvgExport(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11 5.414V15h2V5.414l1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5 8a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3h-2a1 1 0 1 0 0 2h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1 1 0 0 0 0-2z"
		})]
	});
}
//#endregion
//#region src/FilterList.tsx
function SvgFilterList(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M22 6a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h18a1 1 0 0 1 1 1m-3 6a1 1 0 0 1-1 1H6a1 1 0 1 1 0-2h12a1 1 0 0 1 1 1m-3 7a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2z"
		})
	});
}
//#endregion
//#region src/Firefly.tsx
function SvgFirefly(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.015 3.765a4.66 4.66 0 0 1 4.407 1.206l6.225 6.164c.199.196.28.45.266.694a.92.92 0 0 1-.245.68l-6.016 6.427c-1.117 1.194-2.76 1.697-4.33 1.315-3.472-.845-4.693-5.269-2.247-7.898l.297-.319-.508-.506C1.31 8.985 2.518 4.641 6.015 3.765m.745 14.681c-2.021-.492-2.855-3.183-1.326-4.827l.282-.304a5.74 5.74 0 0 0 5.234.972l2.12-.653-3.774 4.033c-.669.715-1.631 1-2.536.78ZM18.75 3.625a3.125 3.125 0 1 1 0 6.25 3.125 3.125 0 0 1 0-6.25",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Flag.tsx
function SvgFlag(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7 4a1 1 0 0 0-1 1v15a1 1 0 1 0 2 0v-7h9a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H8V5a1 1 0 0 0-1-1"
		})
	});
}
//#endregion
//#region src/GasStation.tsx
function SvgGasStation(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4 21V5q0-.824.588-1.413A1.93 1.93 0 0 1 6 3h6q.825 0 1.412.587Q14 4.176 14 5v7h1q.824 0 1.413.588Q17 13.175 17 14v4.5q0 .424.288.712.287.288.712.288c.425 0 .52-.096.712-.288A.97.97 0 0 0 19 18.5v-7.2q-.225.125-.475.162A3.5 3.5 0 0 1 18 11.5q-1.05 0-1.775-.725T15.5 9q0-.8.438-1.438A2.4 2.4 0 0 1 17.1 6.65L15 4.55l1.05-1.05 3.7 3.6q.375.375.563.875T20.5 9v9.5q0 1.05-.725 1.775T18 21c-1.05 0-1.292-.242-1.775-.725Q15.5 19.55 15.5 18.5v-5H14V21zm2-11h6V5H6zm12 0a.97.97 0 0 0 .712-.287A.97.97 0 0 0 19 9a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18 8a.97.97 0 0 0-.712.287A.97.97 0 0 0 17 9q0 .424.288.713A.97.97 0 0 0 18 10"
		})
	});
}
//#endregion
//#region src/Globe.tsx
function SvgGlobe(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10m-8.253 6.177C12.948 19.774 12.215 20 12 20s-.948-.226-1.747-1.823c-.639-1.278-1.11-3.083-1.226-5.177h5.946c-.116 2.094-.587 3.899-1.226 5.177M14.973 11H9.027c.116-2.094.587-3.899 1.226-5.177C11.052 4.226 11.785 4 12 4s.948.226 1.747 1.823c.639 1.278 1.11 3.083 1.226 5.177m2.002 2c-.12 2.434-.678 4.61-1.512 6.214A8 8 0 0 0 19.938 13zm2.963-2h-2.963c-.12-2.434-.678-4.61-1.512-6.214A8 8 0 0 1 19.938 11M7.025 11c.12-2.434.678-4.61 1.512-6.214A8 8 0 0 0 4.062 11zm-2.963 2a8 8 0 0 0 4.475 6.214C7.703 17.61 7.145 15.434 7.025 13z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Handler.tsx
function SvgHandler(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M19.354 11.354a.5.5 0 0 0-.708-.708l-8 8a.5.5 0 0 0 .708.708zm0 4a.5.5 0 0 0-.708-.708l-4 4a.5.5 0 0 0 .708.708z"
		})
	});
}
//#endregion
//#region src/Home.tsx
function SvgHome(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4 10a2 2 0 0 1 .8-1.6l6-4.5a2 2 0 0 1 2.4 0l6 4.5A2 2 0 0 1 20 10v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm14 0v9H6v-9l6-4.5z",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/ImageIcon.tsx
function SvgImageIcon(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7 3a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4zm10 2H7a2 2 0 0 0-2 2v5.634l2.994-1.437a2 2 0 0 1 2.132.255l4.396 3.597L19 11.629V7a2 2 0 0 0-2-2M5 17v-2.148L8.86 13l4.395 3.596a2 2 0 0 0 2.48.042L19 14.145V17a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/ImportPass.tsx
function SvgImportPass(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 2h1v9l2-2 1.414 1.414-3.707 3.293a1 1 0 0 1-1.414 0l-3.707-3.293L9 9l2 2V2z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8 4c-4.275 0-7 3.175-7 7 0 3.406 2.627 6.141 5.975 6.829.471.097.692.434.692.671v2.043c0 1.428 1.807 2.048 2.684.92L13.045 18h2.288C19.466 18 23 14.963 23 11c0-3.825-2.725-7-7-7a1 1 0 1 0 0 2c3.09 0 5 2.197 5 5 0 2.665-2.435 5-5.667 5h-3.267l-2.4 3.085V18.5c0-.729-.219-1.546-.666-2-.424-.43-1.062-.515-1.622-.63C4.797 15.34 3 13.3 3 11c0-2.803 1.91-5 5-5a1 1 0 0 0 0-2"
		})]
	});
}
//#endregion
//#region src/Info.tsx
function SvgInfo(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-14.4A1.2 1.2 0 1 0 12 9a1.2 1.2 0 0 0 0-2.4m1.2 9a1.2 1.2 0 0 1-2.4 0V12a1.2 1.2 0 0 1 2.4 0z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/IotaLogoMark.tsx
function SvgIotaLogoMark(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M18.27 2.259c0 .695-.568 1.259-1.268 1.259s-1.267-.564-1.267-1.259S16.302 1 17.002 1s1.268.564 1.268 1.259m1.425 17.785c0 .695-.568 1.259-1.268 1.259s-1.267-.564-1.267-1.26c0-.695.567-1.258 1.267-1.258s1.268.563 1.268 1.259m-2.33-13.379a1.06 1.06 0 0 0 1.063-1.056 1.06 1.06 0 0 0-1.063-1.057A1.06 1.06 0 0 0 16.3 5.61a1.06 1.06 0 0 0 1.064 1.056Zm3.891-.651a1.06 1.06 0 0 1-1.063 1.056 1.06 1.06 0 0 1-1.064-1.056 1.06 1.06 0 0 1 1.064-1.057 1.06 1.06 0 0 1 1.063 1.057m-4.253 3.329c.5 0 .905-.403.905-.9 0-.496-.405-.9-.905-.9s-.906.404-.906.9c0 .497.406.9.906.9m3.734-.52c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.496.405-.9.906-.9.5 0 .905.404.905.9m1.357 1.777c.5 0 .906-.402.906-.899s-.405-.9-.906-.9c-.5 0-.905.403-.905.9s.405.9.905.9Zm-2.309.495a.79.79 0 0 1-.792.787.79.79 0 0 1-.791-.787c0-.434.354-.786.791-.786s.792.352.792.786m-3.62.404a.79.79 0 0 0 .792-.787.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .435.354.787.791.787m5.907.471a.79.79 0 0 1-.791.787.79.79 0 0 1-.792-.786.79.79 0 0 1 .792-.787.79.79 0 0 1 .791.787Zm-4.21 1.554c.375 0 .68-.302.68-.675a.677.677 0 0 0-.68-.675.68.68 0 0 0-.68.675c0 .373.304.675.68.675m2.968.178a.68.68 0 0 1-.68.676.677.677 0 0 1-.68-.676c0-.373.304-.675.68-.675.375 0 .68.302.68.675m-5.774-.582c.375 0 .68-.302.68-.675a.68.68 0 0 0-.68-.675.68.68 0 0 0-.68.675c0 .373.304.675.68.675m2.127.943c0 .31-.254.561-.566.561a.564.564 0 0 1-.566-.562c0-.31.253-.561.566-.561s.566.251.566.562m.407 2.114a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m-.791-.09a.407.407 0 0 1-.408.405.407.407 0 0 1-.408-.405c0-.223.182-.405.408-.405s.408.181.408.405m-1.472-.765a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m-.973-1.64c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.566.251.566.562m-.588-3.666a.564.564 0 0 0 .566-.562.564.564 0 0 0-.566-.562.564.564 0 0 0-.565.562c0 .31.253.562.565.562m.745-2.473a.496.496 0 0 1-.497.494.496.496 0 0 1-.498-.494c0-.273.223-.494.498-.494s.498.22.498.494Zm.047-1.123a.406.406 0 0 0 .407-.406.406.406 0 0 0-.407-.405.407.407 0 0 0-.408.405c0 .224.182.406.408.406m-.452-1.26a.496.496 0 0 1-.498.494.496.496 0 0 1-.498-.494c0-.273.223-.494.498-.494s.498.22.498.494m4.776 10.32a.564.564 0 0 0 .566-.561.564.564 0 0 0-.566-.562.564.564 0 0 0-.566.562c0 .31.253.562.566.562ZM12.883 4.439c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.254-.562.566-.562s.566.251.566.562m-.18 2.945a.564.564 0 0 0 .566-.562.564.564 0 0 0-.566-.561.564.564 0 0 0-.566.561c0 .31.253.562.566.562m.045 1.597a.677.677 0 0 1-.68.676.68.68 0 0 1-.679-.676c0-.373.304-.675.68-.675.375 0 .68.302.68.675Zm-2.74.676a.79.79 0 0 0 .791-.786.79.79 0 0 0-.791-.787.79.79 0 0 0-.792.787c0 .434.354.786.792.786m-1.494-.36c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.497.406-.9.906-.9s.905.403.905.9m-3.529 2.18a1.06 1.06 0 0 0 1.063-1.056 1.06 1.06 0 0 0-1.063-1.056A1.06 1.06 0 0 0 3.92 10.42a1.06 1.06 0 0 0 1.064 1.056Zm-1.45.9c0 .696-.568 1.26-1.268 1.26S1 13.073 1 12.377c0-.695.567-1.259 1.267-1.259s1.268.564 1.268 1.26Zm.386-3.531A1.06 1.06 0 0 0 4.985 7.79 1.06 1.06 0 0 0 3.92 6.733 1.06 1.06 0 0 0 2.858 7.79 1.06 1.06 0 0 0 3.92 8.846Zm3.53-2.181c0 .497-.405.9-.906.9a.903.903 0 0 1-.905-.9c0-.496.405-.9.905-.9s.906.404.906.9M6.162 5.182c.5 0 .905-.403.905-.9 0-.496-.405-.9-.905-.9s-.906.404-.906.9c0 .497.406.9.906.9m3.19-1.326a.79.79 0 0 1-.791.787.79.79 0 0 1-.792-.787c0-.434.354-.786.792-.786.437 0 .791.352.791.786m1.268.788c.375 0 .68-.303.68-.675a.677.677 0 0 0-.68-.676.68.68 0 0 0-.68.675c0 .373.304.676.68.676m1.063 1.708a.68.68 0 0 1-.68.675.677.677 0 0 1-.68-.675c0-.373.305-.675.68-.675s.68.302.68.675m-2.739.695a.79.79 0 0 0 .792-.786.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .434.354.786.791.786m-1.832 5.578a.407.407 0 0 1-.408.405.407.407 0 0 1-.408-.405c0-.223.182-.405.408-.405s.408.181.408.405m1.221.201a.496.496 0 0 0 .497-.494.496.496 0 0 0-.497-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m2.354-1.236c0 .31-.253.562-.565.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.565.252.565.562m-.135 2.361c.375 0 .68-.302.68-.675a.677.677 0 0 0-.68-.675.677.677 0 0 0-.68.675c0 .373.304.675.68.675m-1.608-.135c0 .31-.253.562-.566.562a.564.564 0 0 1-.565-.562c0-.31.253-.562.565-.562.313 0 .566.252.566.562m-2.488.538a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m.588.991c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.566.252.566.562m1.742.855c.376 0 .68-.303.68-.675a.677.677 0 0 0-.68-.676.677.677 0 0 0-.68.675c0 .373.305.676.68.676m3.484-1.08a.79.79 0 0 1-.79.786.79.79 0 0 1-.792-.786c0-.435.354-.787.791-.787s.792.352.792.787Zm.794 2.743c.5 0 .906-.402.906-.9 0-.496-.406-.899-.906-.899s-.905.403-.905.9.405.9.905.9Zm-2.536-.518a.79.79 0 0 1-.792.786.79.79 0 0 1-.792-.787.79.79 0 0 1 .792-.786.79.79 0 0 1 .792.787m-2.669 2.316a.79.79 0 0 0 .791-.786.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .434.354.786.792.786m2.466 1.079c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.496.405-.9.906-.9.5 0 .905.404.905.9M13.584 22a1.06 1.06 0 0 0 1.064-1.056 1.06 1.06 0 0 0-1.064-1.057 1.06 1.06 0 0 0-1.063 1.057A1.06 1.06 0 0 0 13.584 22m-1.379-2.788c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.497.405-.9.905-.9s.906.403.906.9m3.123.54a1.06 1.06 0 0 0 1.063-1.057 1.06 1.06 0 0 0-1.063-1.056 1.06 1.06 0 0 0-1.064 1.056 1.06 1.06 0 0 0 1.064 1.057m-7.741-2.699a.677.677 0 0 1-.68.676.677.677 0 0 1-.68-.676c0-.373.305-.675.68-.675s.68.302.68.675"
		})
	});
}
//#endregion
//#region src/IotaLogoSmall.tsx
function SvgIotaLogoSmall(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.13 4.02c0 .562-.464 1.018-1.037 1.018a1.03 1.03 0 0 1-1.037-1.019c0-.563.464-1.019 1.037-1.019s1.037.456 1.037 1.02m1.166 14.396a1.03 1.03 0 0 1-1.037 1.02 1.03 1.03 0 0 1-1.037-1.02c0-.563.464-1.019 1.037-1.019.572 0 1.037.456 1.037 1.02ZM16.39 7.586c.48 0 .87-.383.87-.855a.863.863 0 0 0-.87-.855c-.481 0-.87.383-.87.855s.389.855.87.855m3.183-.527c0 .472-.39.855-.87.855a.863.863 0 0 1-.87-.855c0-.473.39-.855.87-.855s.87.382.87.855m-3.48 2.695c.41 0 .741-.326.741-.728a.735.735 0 0 0-.74-.729.736.736 0 0 0-.742.729c0 .402.332.728.741.728m3.056-.421a.735.735 0 0 1-.741.729.735.735 0 0 1-.741-.729c0-.402.331-.728.74-.728.41 0 .742.326.742.728m1.111 1.439c.408 0 .74-.326.74-.728a.735.735 0 0 0-.74-.728.735.735 0 0 0-.742.728c0 .402.332.728.741.728Zm-1.89.4c0 .352-.29.637-.648.637a.64.64 0 0 1-.648-.636c0-.352.29-.637.648-.637.357 0 .647.285.647.636Zm-2.962.327a.64.64 0 0 0 .647-.636.64.64 0 0 0-.647-.637.64.64 0 0 0-.648.636c0 .352.29.637.648.637m4.832.382c0 .352-.29.637-.647.637a.64.64 0 0 1-.647-.637c0-.351.29-.636.647-.636s.648.285.648.636Zm-3.444 1.258a.55.55 0 0 0 .556-.547.55.55 0 0 0-.556-.546.55.55 0 0 0-.556.546c0 .302.249.547.556.547m2.428.144a.55.55 0 0 1-.556.546.55.55 0 0 1-.556-.546c0-.302.249-.547.556-.547s.556.245.556.547m-4.724-.472a.55.55 0 0 0 .556-.546.55.55 0 0 0-.556-.547.55.55 0 0 0-.556.547c0 .302.25.546.556.546m1.74.763a.46.46 0 0 1-.463.455.46.46 0 0 1-.462-.455c0-.25.207-.454.462-.454.256 0 .463.203.463.454m.334 1.712a.403.403 0 0 0 .407-.4c0-.221-.182-.4-.407-.4a.404.404 0 0 0-.408.4c0 .221.183.4.408.4m-.648-.073a.33.33 0 0 1-.334.328.33.33 0 0 1-.333-.328.33.33 0 0 1 .333-.327.33.33 0 0 1 .334.328Zm-1.204-.619a.404.404 0 0 0 .408-.4c0-.221-.183-.4-.408-.4a.404.404 0 0 0-.407.4c0 .221.182.4.407.4m-.796-1.328a.46.46 0 0 1-.463.455.46.46 0 0 1-.463-.455.46.46 0 0 1 .463-.455.46.46 0 0 1 .463.455m-.481-2.967a.46.46 0 0 0 .463-.455.46.46 0 0 0-.463-.455.46.46 0 0 0-.463.455c0 .25.208.455.463.455m.61-2.002c0 .22-.182.4-.407.4a.404.404 0 0 1-.408-.4c0-.221.183-.4.408-.4s.407.179.407.4m.038-.91a.33.33 0 0 0 .333-.328.33.33 0 0 0-.333-.328.33.33 0 0 0-.334.328c0 .181.15.328.334.328m-.37-1.019c0 .22-.183.4-.408.4a.404.404 0 0 1-.407-.4c0-.221.183-.4.408-.4s.407.179.407.4m3.907 8.355a.46.46 0 0 0 .463-.455.46.46 0 0 0-.462-.455.46.46 0 0 0-.463.455c0 .25.207.455.463.455Zm-4.908-8.939a.46.46 0 0 1-.463.455.46.46 0 0 1-.463-.455.46.46 0 0 1 .463-.455.46.46 0 0 1 .463.455m-.147 2.384a.46.46 0 0 0 .463-.455.46.46 0 0 0-.463-.454.46.46 0 0 0-.463.454c0 .252.207.455.463.455m.037 1.293a.55.55 0 0 1-.556.547.55.55 0 0 1-.556-.547c0-.302.25-.547.556-.547s.556.245.556.547m-2.242.547a.64.64 0 0 0 .648-.637.64.64 0 0 0-.648-.636.64.64 0 0 0-.648.636c0 .352.29.637.648.637m-1.222-.291a.735.735 0 0 1-.74.728.735.735 0 0 1-.742-.728c0-.403.332-.729.741-.729.41 0 .741.326.741.729M6.26 11.482c.48 0 .87-.383.87-.855a.863.863 0 0 0-.87-.856c-.48 0-.87.383-.87.855 0 .473.39.856.87.856m-1.186.728c0 .563-.464 1.02-1.037 1.02A1.03 1.03 0 0 1 3 12.21c0-.563.464-1.019 1.037-1.019s1.037.456 1.037 1.02Zm.316-2.858c.48 0 .87-.383.87-.856a.863.863 0 0 0-.87-.855c-.48 0-.87.383-.87.855 0 .473.39.856.87.856m2.888-1.766a.735.735 0 0 1-.74.729.735.735 0 0 1-.742-.729c0-.402.332-.728.741-.728.41 0 .741.326.741.728m-1.055-1.2c.41 0 .741-.327.741-.729a.735.735 0 0 0-.74-.728.735.735 0 0 0-.742.728c0 .402.332.729.741.729m2.611-1.074c0 .352-.29.637-.648.637a.64.64 0 0 1-.648-.637c0-.351.29-.636.648-.636s.648.285.648.636m1.036.638a.55.55 0 0 0 .557-.547.55.55 0 0 0-.557-.547.55.55 0 0 0-.556.547c0 .302.25.547.556.547m.87 1.383a.55.55 0 0 1-.556.546.55.55 0 0 1-.556-.546c0-.302.25-.547.556-.547.308 0 .557.245.557.547Zm-2.24.563a.64.64 0 0 0 .648-.637.64.64 0 0 0-.648-.637.64.64 0 0 0-.648.637c0 .352.29.637.648.637M8 12.41a.33.33 0 0 1-.333.329.33.33 0 0 1-.334-.328.33.33 0 0 1 .334-.328.33.33 0 0 1 .333.328Zm1 .163a.404.404 0 0 0 .407-.4c0-.22-.183-.4-.408-.4a.404.404 0 0 0-.407.4c0 .221.183.4.407.4Zm1.926-1a.46.46 0 0 1-.463.455.46.46 0 0 1-.463-.455c0-.252.208-.455.463-.455a.46.46 0 0 1 .463.455m-.111 1.911a.55.55 0 0 0 .556-.546.55.55 0 0 0-.556-.547.55.55 0 0 0-.556.547.55.55 0 0 0 .556.546M9.5 13.375a.46.46 0 0 1-.463.455.46.46 0 0 1-.463-.455c0-.251.207-.455.463-.455s.463.204.463.455m-2.036.435a.403.403 0 0 0 .407-.4c0-.22-.182-.4-.407-.4a.404.404 0 0 0-.407.4c0 .221.182.4.407.4m.481.803a.46.46 0 0 1-.463.455.46.46 0 0 1-.463-.455c0-.252.207-.455.463-.455s.463.204.463.455m1.425.692a.55.55 0 0 0 .557-.547.55.55 0 0 0-.556-.547.55.55 0 0 0-.557.547c0 .302.25.547.557.547Zm2.852-.875c0 .352-.29.637-.648.637a.64.64 0 0 1-.648-.637c0-.351.29-.636.648-.636s.648.285.648.636m.648 2.221c.41 0 .742-.326.742-.728a.735.735 0 0 0-.741-.728.734.734 0 0 0-.741.728c0 .402.331.728.74.728m-2.075-.42c0 .352-.29.637-.647.637a.64.64 0 0 1-.648-.637c0-.351.29-.636.648-.636.357 0 .647.285.647.636m-2.184 1.876a.64.64 0 0 0 .648-.637.64.64 0 0 0-.648-.636.64.64 0 0 0-.647.636c0 .352.29.637.647.637m2.019.873a.735.735 0 0 1-.741.729.735.735 0 0 1-.741-.729c0-.402.332-.728.74-.728.41 0 .742.326.742.728M13.296 20c.48 0 .87-.383.87-.855a.863.863 0 0 0-.87-.855c-.48 0-.87.383-.87.855s.39.855.87.855m-1.128-2.257a.735.735 0 0 1-.741.729.735.735 0 0 1-.741-.729c0-.402.332-.728.74-.728.41 0 .742.326.742.728m2.555.437c.48 0 .87-.383.87-.855a.863.863 0 0 0-.87-.856.863.863 0 0 0-.87.856c0 .472.389.855.87.855M8.39 15.996a.55.55 0 0 1-.557.546.55.55 0 0 1-.556-.546c0-.302.25-.547.556-.547s.556.245.556.547Z"
		})
	});
}
//#endregion
//#region src/IotaLogoWeb.tsx
function SvgIotaLogoWeb(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 137 36",
		...props,
		children: [/* @__PURE__ */ jsxs("g", {
			fill: "currentColor",
			clipPath: "url(#iota_logo_web_svg__a)",
			children: [/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M76.175 6.28c-6.361 0-11.77 5.516-11.77 12.028 0 6.553 5.445 12.065 11.77 12.027 6.36 0 11.73-5.474 11.73-12.027S82.573 6.281 76.175 6.281Zm0 2.469c4.951 0 9.102 4.395 9.102 9.559 0 5.205-4.15 9.596-9.102 9.596s-9.14-4.39-9.14-9.596c0-5.164 4.188-9.56 9.14-9.56Z",
				clipRule: "evenodd"
			}), /* @__PURE__ */ jsx("path", { d: "M53.32 6.706h2.627v23.241H53.32V6.707Zm48.067 2.506h-7.73V6.706h18.053v2.506h-7.733v20.735h-2.627zm15.386 20.735 8.722-20.003 8.649 20.003H137l-9.56-21.93a2.12 2.12 0 0 0-1.982-1.31c-.837 0-1.638.5-1.981 1.31l-9.56 21.93zM26.928 4.317c1.178 0 2.132-.967 2.132-2.159S28.106 0 26.928 0s-2.133.966-2.133 2.158.955 2.159 2.133 2.159m2.398 30.488c1.178 0 2.133-.966 2.133-2.158s-.955-2.159-2.133-2.159-2.133.967-2.133 2.159.955 2.158 2.133 2.158M27.537 9.712a1.8 1.8 0 0 0 1.789-1.81 1.8 1.8 0 0 0-1.79-1.812 1.8 1.8 0 0 0-1.789 1.811 1.8 1.8 0 0 0 1.79 1.811m4.759.695a1.8 1.8 0 0 0 1.79-1.811 1.8 1.8 0 0 0-1.79-1.811 1.8 1.8 0 0 0-1.79 1.81 1.8 1.8 0 0 0 1.79 1.812m-5.368 3.894c.841 0 1.524-.69 1.524-1.542 0-.851-.683-1.542-1.524-1.542-.842 0-1.524.69-1.524 1.542s.682 1.542 1.524 1.542m4.76.654c.841 0 1.523-.69 1.523-1.542s-.682-1.542-1.523-1.542c-.842 0-1.524.69-1.524 1.542 0 .851.682 1.542 1.523 1.542Zm3.807 1.505c.842 0 1.524-.69 1.524-1.543 0-.851-.682-1.542-1.524-1.542-.841 0-1.524.69-1.524 1.543 0 .851.683 1.542 1.524 1.542m-5.217 2.195a1.34 1.34 0 0 0 1.332-1.348 1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348m-4.76-.657a1.34 1.34 0 0 0 1.332-1.348 1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348m8.608 2.158a1.34 1.34 0 0 0 1.332-1.348 1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348m-5.752 1.314a1.15 1.15 0 0 0 1.144-1.157 1.15 1.15 0 0 0-1.144-1.157 1.15 1.15 0 0 0-1.144 1.157c0 .64.512 1.158 1.144 1.158Zm3.848 1.465a1.15 1.15 0 0 0 1.144-1.158 1.15 1.15 0 0 0-1.144-1.158 1.15 1.15 0 0 0-1.143 1.158c0 .64.512 1.158 1.143 1.158m-8.571-2.159a1.15 1.15 0 0 0 1.144-1.157 1.15 1.15 0 0 0-1.144-1.158 1.15 1.15 0 0 0-1.144 1.158 1.15 1.15 0 0 0 1.144 1.157m2.627 2.581a.96.96 0 0 0 .952-.964.96.96 0 0 0-.952-.963.96.96 0 0 0-.952.963c0 .532.427.963.952.963Zm1.639 2.662c.462 0 .837-.38.837-.848a.843.843 0 0 0-.837-.847.843.843 0 0 0-.838.847c0 .468.375.848.838.848m-2.019.538a.69.69 0 0 0 .687-.695.69.69 0 0 0-.687-.694.69.69 0 0 0-.686.694.69.69 0 0 0 .686.695m-1.789-2.006c.462 0 .837-.38.837-.847a.843.843 0 0 0-.837-.848.843.843 0 0 0-.838.848c0 .468.375.847.838.847m-2.59-1.848a.96.96 0 0 0 .952-.963.96.96 0 0 0-.952-.964.96.96 0 0 0-.952.964c0 .532.426.963.952.963m-.037-7.248a.96.96 0 0 0 .952-.963.96.96 0 0 0-.952-.964.96.96 0 0 0-.952.964c0 .532.426.963.952.963m.417-3.39c.462 0 .837-.38.837-.848a.843.843 0 0 0-.837-.848.843.843 0 0 0-.838.848c0 .468.375.848.838.848m.915-2.775a.69.69 0 0 0 .686-.694.69.69 0 0 0-.686-.695.69.69 0 0 0-.687.695.69.69 0 0 0 .687.694m-1.598-1.31c.463 0 .838-.38.838-.848a.843.843 0 0 0-.838-.848.843.843 0 0 0-.838.848c0 .468.375.848.838.848m8.874 16.844a.96.96 0 0 0 .952-.963.96.96 0 0 0-.952-.964.96.96 0 0 0-.952.964c0 .532.426.963.952.963M19.043 6.86a.96.96 0 0 0 .952-.964.96.96 0 0 0-.952-.963.96.96 0 0 0-.952.963c0 .532.426.963.952.963Zm.649 4.084a.96.96 0 0 0 .952-.963.96.96 0 0 0-.952-.963.96.96 0 0 0-.952.963c0 .532.426.963.952.963m-1.066 3.896a1.15 1.15 0 0 0 1.144-1.158 1.15 1.15 0 0 0-1.144-1.158 1.15 1.15 0 0 0-1.144 1.158 1.15 1.15 0 0 0 1.144 1.157Zm-3.469 0a1.34 1.34 0 0 0 1.332-1.349 1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348Zm-4.037.925c.843 0 1.525-.69 1.525-1.542s-.682-1.542-1.524-1.542-1.524.69-1.524 1.542.682 1.542 1.524 1.542ZM6.704 17.96a1.8 1.8 0 0 0 1.79-1.81 1.8 1.8 0 0 0-1.79-1.811 1.8 1.8 0 0 0-1.79 1.81 1.8 1.8 0 0 0 1.79 1.812Zm-4.571 3.701c1.178 0 2.132-.966 2.132-2.158s-.954-2.158-2.132-2.158S0 18.31 0 19.503s.955 2.158 2.133 2.158m2.782-8.211a1.8 1.8 0 0 0 1.79-1.811 1.8 1.8 0 0 0-1.79-1.811 1.8 1.8 0 0 0-1.79 1.811 1.8 1.8 0 0 0 1.79 1.811m4.416-2.196c.842 0 1.524-.69 1.524-1.542 0-.851-.682-1.542-1.524-1.542-.841 0-1.524.69-1.524 1.542s.683 1.542 1.524 1.542M8.686 7.17c.841 0 1.524-.691 1.524-1.543 0-.851-.683-1.542-1.524-1.542-.842 0-1.524.69-1.524 1.542s.682 1.542 1.524 1.542Zm4.036-.927a1.34 1.34 0 0 0 1.332-1.348 1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348m3.465.004A1.15 1.15 0 0 0 17.33 5.09a1.15 1.15 0 0 0-1.144-1.158 1.15 1.15 0 0 0-1.144 1.158 1.15 1.15 0 0 0 1.144 1.157Zm.646 4.085a1.15 1.15 0 0 0 1.143-1.157 1.15 1.15 0 0 0-1.143-1.158 1.15 1.15 0 0 0-1.144 1.158 1.15 1.15 0 0 0 1.144 1.157m-3.465.034A1.34 1.34 0 0 0 14.7 9.018a1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348M9.597 20.623a.69.69 0 0 0 .686-.694.69.69 0 0 0-.686-.695.69.69 0 0 0-.686.695.69.69 0 0 0 .686.694m2.741-.351c.463 0 .838-.38.838-.848a.843.843 0 0 0-.838-.847.843.843 0 0 0-.837.847c0 .469.375.848.838.848Zm3.012-1.154a.96.96 0 0 0 .951-.963.96.96 0 0 0-.952-.963.96.96 0 0 0-.952.963c0 .532.427.963.952.963Zm.723 3.085a1.15 1.15 0 0 0 1.143-1.158 1.15 1.15 0 0 0-1.143-1.157 1.15 1.15 0 0 0-1.144 1.157c0 .64.512 1.158 1.144 1.158m-3.657.731a.96.96 0 0 0 .952-.963.96.96 0 0 0-.952-.963.96.96 0 0 0-.952.963c0 .532.426.963.952.963m-3.236-.041a.84.84 0 0 0 .838-.847.843.843 0 0 0-.838-.848.843.843 0 0 0-.838.848c0 .468.375.848.838.848Zm.037 2.663a.96.96 0 0 0 .952-.963.96.96 0 0 0-.952-.964.96.96 0 0 0-.952.963c0 .533.426.964.952.964m3.885.5a1.15 1.15 0 0 0 1.144-1.157 1.15 1.15 0 0 0-1.144-1.158 1.15 1.15 0 0 0-1.144 1.158 1.15 1.15 0 0 0 1.144 1.157m4.531-.504a1.34 1.34 0 0 0 1.332-1.348 1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348m2.667 3.357c.842 0 1.525-.69 1.525-1.542s-.683-1.542-1.524-1.542c-.842 0-1.524.69-1.524 1.542s.682 1.542 1.524 1.542Zm-5.6.459a1.34 1.34 0 0 0 1.332-1.348 1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348m-3.159 2.622a1.34 1.34 0 0 0 1.332-1.348 1.34 1.34 0 0 0-1.332-1.348 1.34 1.34 0 0 0-1.332 1.348 1.34 1.34 0 0 0 1.332 1.348m2.628 3.394c.841 0 1.524-.69 1.524-1.542S15.01 32.3 14.169 32.3c-.842 0-1.524.69-1.524 1.542 0 .851.682 1.542 1.524 1.542m7.006.616a1.8 1.8 0 0 0 1.79-1.811 1.8 1.8 0 0 0-1.79-1.811 1.8 1.8 0 0 0-1.79 1.811A1.8 1.8 0 0 0 21.176 36Zm-3.845-3.237c.842 0 1.525-.69 1.525-1.543 0-.851-.683-1.542-1.524-1.542-.842 0-1.524.69-1.524 1.542s.682 1.543 1.524 1.543Zm6.779-.616a1.8 1.8 0 0 0 1.79-1.812 1.8 1.8 0 0 0-1.79-1.81 1.8 1.8 0 0 0-1.79 1.81 1.8 1.8 0 0 0 1.79 1.812M9.94 28.677a1.15 1.15 0 0 0 1.144-1.157 1.15 1.15 0 0 0-1.144-1.158 1.15 1.15 0 0 0-1.144 1.158c0 .64.512 1.157 1.144 1.157" })]
		}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
			id: "iota_logo_web_svg__a",
			children: /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				d: "M0 0h137v36H0z"
			})
		}) })]
	});
}
//#endregion
//#region src/Key.tsx
function SvgKey(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.5 17a5.5 5.5 0 0 0 5.393-4.413l2.4-.087H22v-1c0-1.105-.395-1.5-1.5-1.5h-8.707A5.5 5.5 0 1 0 6.5 17m0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M18 13.5h4v2h-4z"
		})]
	});
}
//#endregion
//#region src/Keystone.tsx
function SvgKeystone(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15.707 22h-4.984c-.57 0-.591-.032-.336-.561.664-1.38 1.337-2.755 1.998-4.136 1.62-3.392 3.24-6.782 4.838-10.184.206-.439.435-.607.94-.594 1.482.04 2.967.022 4.452.008.327-.003.417.073.376.411q-.918 7.37-1.78 14.746c-.065.283-.194.31-.436.308-1.689-.009-3.377-.005-5.066-.005zM13.83 2.004c-.3.638-.574 1.231-.855 1.822C10.88 8.221 8.783 12.613 6.7 17.014c-.164.345-.357.448-.732.443a226 226 0 0 0-4.616-.004c-.284.002-.387-.022-.343-.37.333-2.653.633-5.31.947-7.966.27-2.282.549-4.562.807-6.845.036-.32.229-.27.428-.27h8.865c.57.002 1.137.002 1.773.002Z"
		})
	});
}
//#endregion
//#region src/Ledger.tsx
function SvgLedger(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M3 6a2 2 0 0 1 2-2h3a1 1 0 0 1 0 2H5v3a1 1 0 0 1-2 0zm0 12a2 2 0 0 0 2 2h3a1 1 0 1 0 0-2H5v-3a1 1 0 1 0-2 0zM19 4a2 2 0 0 1 2 2v3a1 1 0 1 1-2 0V6h-3a1 1 0 1 1 0-2zm2 14a2 2 0 0 1-2 2h-3a1 1 0 1 1 0-2h3v-3a1 1 0 1 1 2 0zm-9-4V9a1 1 0 1 0-2 0v5a2 2 0 0 0 2 2h2a1 1 0 1 0 0-2z"
		})
	});
}
//#endregion
//#region src/LightMode.tsx
function SvgLightMode(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M7 12a5 5 0 1 1 10 0 5 5 0 0 1-10 0m5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13 19a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm9-7a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1M5 13a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2zm14.07-8.071a1 1 0 0 1 0 1.414L17.915 7.5A1 1 0 1 1 16.5 6.086l1.157-1.157a1 1 0 0 1 1.414 0ZM7.5 17.914a1 1 0 1 0-1.414-1.415l-1.157 1.158a1 1 0 1 0 1.414 1.414zm11.57 1.157a1 1 0 0 1-1.413 0L16.5 17.914a1 1 0 0 1 1.414-1.414l1.157 1.157a1 1 0 0 1 0 1.414ZM6.086 7.5A1 1 0 1 0 7.5 6.087L6.343 4.93a1 1 0 1 0-1.414 1.414l1.157 1.158Z"
			})
		]
	});
}
//#endregion
//#region src/Link.tsx
function SvgLink(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.828 16.243 12 19.07q-1.467 1.467-3.536 1.467-2.067 0-3.535-1.467t-1.467-3.535q0-2.07 1.467-3.536l2.828-2.828 1.414 1.414-2.828 2.828a2.9 2.9 0 0 0-.884 2.122q0 1.238.884 2.121.884.885 2.121.884c1.237-.001 1.532-.295 2.122-.884l2.828-2.829 1.414 1.415Zm-4.95-.707L8.465 14.12l5.657-5.656 1.414 1.414-5.656 5.657Zm6.365-.707-1.415-1.415 2.829-2.828q.884-.884.884-2.121c0-1.237-.295-1.532-.884-2.122a2.9 2.9 0 0 0-2.122-.884 2.9 2.9 0 0 0-2.12.884l-2.83 2.829-1.414-1.415L12 4.93q1.468-1.467 3.535-1.467 2.07 0 3.536 1.467t1.467 3.536-1.467 3.535z"
		})
	});
}
//#endregion
//#region src/ListViewLarge.tsx
function SvgListViewLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M6 5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm0 8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm7-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm1 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
		})
	});
}
//#endregion
//#region src/ListViewMedium.tsx
function SvgListViewMedium(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3 7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm4 0H5v2h2zm-4 8a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm4 0H5v2h2z",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 11a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-1-5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1m1 11a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2z"
		})]
	});
}
//#endregion
//#region src/ListViewSmall.tsx
function SvgListViewSmall(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M9 5a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2zm0 6a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m-3-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
		})
	});
}
//#endregion
//#region src/Loader.tsx
function SvgLoader(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.533 9.321A7 7 0 1 0 19 12a1 1 0 1 1 2 0 9 9 0 1 1-9-9 1 1 0 1 1 0 2 7 7 0 0 0-6.467 4.321",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Loader2.tsx
function SvgLoader2(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-5.656-2.343a2 2 0 1 1-.001 4.001 2 2 0 0 1 0-4Zm11.313 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4M4 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4m16 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4M6.344 4.344a2 2 0 1 1-.001 4 2 2 0 0 1 0-4Zm11.313-.001a2 2 0 1 1 0 4 2 2 0 0 1 0-4M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
		})
	});
}
//#endregion
//#region src/LockLocked.tsx
function SvgLockLocked(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8 11V8.104C8 6.176 9.577 5 11.5 5s3.482 1.176 3.482 3.104L15 11h2.018L17 8.104C17 5.285 14.31 3 11.5 3S6 5.285 6 8.104V11c-1.183 0-2 .962-2 2.15v5.7C4 20.039 4.96 21 6.143 21h10.714A2.146 2.146 0 0 0 19 18.85v-5.7c0-1.188-.817-2.15-2-2.15zm5.321 5.272c0 .95-.767 1.72-1.714 1.72s-1.714-.77-1.714-1.72.767-1.72 1.714-1.72 1.714.77 1.714 1.72",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/LockUnlocked.tsx
function SvgLockUnlocked(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8 11V8.104C8 6.5 9.577 5 11.5 5S15 6.5 15 8h2c0-2.82-2.69-5-5.5-5S6 5.285 6 8.104V11c-1.183 0-2 .962-2 2.15v5.7C4 20.039 4.96 21 6.143 21h10.714A2.146 2.146 0 0 0 19 18.85v-5.7c0-1.188-.96-2.15-2.143-2.15zm5.321 5.272c0 .95-.767 1.72-1.714 1.72s-1.714-.77-1.714-1.72.767-1.72 1.714-1.72 1.714.77 1.714 1.72",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Logout.tsx
function SvgLogout(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M18.586 10.793H10a1 1 0 1 0 0 2h8.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3A1 1 0 1 0 17.293 9.5z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15 6a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-1a1 1 0 1 0-2 0v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 1 0 2 0z"
		})]
	});
}
//#endregion
//#region src/Mail.tsx
function SvgMail(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18.206 4.005A4 4 0 0 1 22 8v8l-.005.206a4 4 0 0 1-3.789 3.79L18 20H6l-.206-.005A4 4 0 0 1 2 16V8a4 4 0 0 1 3.794-3.995L6 4h12zm-4.23 8.596a3 3 0 0 1-3.733.173l-.219-.173L4.09 7.406A2 2 0 0 0 4 8v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-.09-.594zM6 6q-.22.001-.428.047l5.77 5.048.073.058a1 1 0 0 0 1.244-.058l5.768-5.048A2 2 0 0 0 18 6z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/MenuIcon.tsx
function SvgMenuIcon(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21 9a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1m0 6a1 1 0 0 1-1 1H10a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1"
		})
	});
}
//#endregion
//#region src/Migration.tsx
function SvgMigration(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.72 3.139c-.266-.297-.72-.087-.72.333V6h-1a6 6 0 0 0-6 6 4 4 0 0 1-4 4H4a1 1 0 0 0 0 2h2a6 6 0 0 0 6-6 4 4 0 0 1 4-4h1v2.528c0 .42.454.63.72.333l3.157-3.528a.51.51 0 0 0 0-.666z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.72 13.139c-.266-.297-.72-.087-.72.333V16h-1a4 4 0 0 1-3.139-1.52 3.5 3.5 0 0 1-1.14 1.726A5.98 5.98 0 0 0 15.999 18H17v2.528c0 .42.454.63.72.333l3.157-3.528a.51.51 0 0 0 0-.666zm-7.44-5.344A5.98 5.98 0 0 0 6 6H4a1 1 0 1 0 0 2h2c1.273 0 2.407.594 3.139 1.52.2-.685.603-1.284 1.14-1.725Z"
		})]
	});
}
//#endregion
//#region src/MoreHoriz.tsx
function SvgMoreHoriz(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m9-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
		})
	});
}
//#endregion
//#region src/MoreVert.tsx
function SvgMoreVert(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M10 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0m2 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
		})
	});
}
//#endregion
//#region src/Notifications.tsx
function SvgNotifications(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 2a2 2 0 0 1 2 2v.342c2.33.824 4 3.046 4 5.658v2c0 1.157.172 2.367.925 3.246l.112.131A4 4 0 0 1 20 17.98V19a1 1 0 0 1-1 1h-4.176a3 3 0 0 1-.703 1.121 3 3 0 0 1-4.242 0A3 3 0 0 1 9.176 20H5a1 1 0 0 1-1-1v-1.02a4 4 0 0 1 .963-2.603l.112-.13C5.827 14.366 6 13.156 6 12v-2a6 6 0 0 1 4-5.658V4a2 2 0 0 1 2-2m0 4a4 4 0 0 0-4 4v2c0 1.188-.147 2.873-1.186 4.271l-.22.276-.112.13v.002a2 2 0 0 0-.474 1.123L6 17.98V18h12v-.02c0-.418-.131-.823-.372-1.16l-.11-.141-.112-.132C16.166 15.1 16 13.266 16 12v-2l-.005-.206a4 4 0 0 0-3.789-3.79z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/OutboundLink.tsx
function SvgOutboundLink(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5 6a1 1 0 0 1 1-1h2a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-2a1 1 0 1 0-2 0v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M10.515 12.071 17.585 5H13a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V6.414l-7.071 7.071a1 1 0 0 1-1.414-1.414"
		})]
	});
}
//#endregion
//#region src/Pause.tsx
function SvgPause(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm7 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
		})
	});
}
//#endregion
//#region src/PercentDiscount.tsx
function SvgPercentDiscount(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 22q-.6 0-1.15-.225a2.9 2.9 0 0 1-.975-.65q-.725-.725-1.25-.95T7.05 19.95a2.9 2.9 0 0 1-2.125-.875 2.9 2.9 0 0 1-.875-2.125q0-1.05-.225-1.575t-.95-1.25a2.9 2.9 0 0 1-.65-.975A3 3 0 0 1 2 12q0-.6.225-1.15a2.9 2.9 0 0 1 .65-.975q.725-.725.95-1.25T4.05 7.05q0-1.25.875-2.125A2.9 2.9 0 0 1 7.05 4.05q1.05 0 1.575-.225t1.25-.95q.425-.425.975-.65A3 3 0 0 1 12 2q.6 0 1.15.225t.975.65q.725.725 1.25.95t1.575.225q1.25 0 2.125.875c.875.875.875 1.292.875 2.125q0 1.05.225 1.575t.95 1.25q.425.425.65.975T22 12t-.225 1.15a2.9 2.9 0 0 1-.65.975q-.725.725-.95 1.25t-.225 1.575q0 1.25-.875 2.125a2.9 2.9 0 0 1-2.125.875q-1.05 0-1.575.225t-1.25.95a2.9 2.9 0 0 1-.975.65A3 3 0 0 1 12 22m2.5-6q.624 0 1.063-.438Q16 15.125 16 14.5q0-.624-.438-1.063A1.45 1.45 0 0 0 14.5 13q-.624 0-1.063.438A1.45 1.45 0 0 0 13 14.5q0 .624.438 1.063.437.437 1.062.437m-5.75.25a.99.99 0 0 0 1.4 0l5.1-6.1a.99.99 0 1 0-1.4-1.4l-5.1 6.1a.99.99 0 0 0 0 1.4m1.813-5.688Q11 10.126 11 9.5q0-.624-.438-1.063A1.45 1.45 0 0 0 9.5 8q-.624 0-1.063.438A1.45 1.45 0 0 0 8 9.5q0 .624.438 1.063Q8.875 11 9.5 11q.624 0 1.063-.438"
		})
	});
}
//#endregion
//#region src/Person.tsx
function SvgPerson(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.422 13.375a5 5 0 1 0-4.844 0A8 8 0 0 0 4 21h2a6 6 0 1 1 12 0h2a8 8 0 0 0-5.578-7.625M15 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Pined.tsx
function SvgPined(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m16 12 2 2v2h-5v6l-1 1-1-1v-6H6v-2l2-2V5H7V3h10v2h-1z"
		})
	});
}
//#endregion
//#region src/PlaceholderReplace.tsx
function SvgPlaceholderReplace(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 8a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6zm2 0a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3.871a19.13 19.13 0 0 1-16 0zm0 6.051V16a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-1.949a21.13 21.13 0 0 1-16 0",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/Play.tsx
function SvgPlay(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M19.364 13.118c.848-.497.848-1.739 0-2.236L7.909 4.175C7.061 3.678 6 4.299 6 5.293v13.414c0 .994 1.06 1.615 1.91 1.118z"
		})
	});
}
//#endregion
//#region src/Profile.tsx
function SvgProfile(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 0 0-5.809 13.498 8 8 0 0 1 11.617 0A7.97 7.97 0 0 0 20 12a8 8 0 0 0-8-8",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
		})]
	});
}
//#endregion
//#region src/QrCode.tsx
function SvgQrCode(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm4 2H5v4h4zm-4 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm4 2H5v4h4zm4-10a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm2 0h4v4h-4z",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1-6a2 2 0 0 1 2-2h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0zm6 6a2 2 0 0 0 2-2v-1a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2z"
		})]
	});
}
//#endregion
//#region src/QuestionMarkFilled.tsx
function SvgQuestionMarkFilled(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m-.241 12.999q-.52 0-.889.366a1.19 1.19 0 0 0-.36.88 1.2 1.2 0 0 0 .36.889q.37.366.889.366.332 0 .612-.167a1.35 1.35 0 0 0 .452-.456q.178-.288.183-.633a1.2 1.2 0 0 0-.38-.879 1.2 1.2 0 0 0-.867-.366M11.972 7q-.94 0-1.721.34-.78.335-1.252 1.02-.473.681-.499 1.728h2.12q.016-.43.208-.718.192-.293.494-.44.302-.15.639-.15.348 0 .634.146.29.146.463.419.171.271.171.633 0 .34-.15.617a1.9 1.9 0 0 1-.406.498 5 5 0 0 1-.577.433 3.6 3.6 0 0 0-.738.608q-.306.335-.467.879-.156.545-.162 1.46v.177h1.97v-.177a2.7 2.7 0 0 1 .13-.864q.13-.35.39-.617a3.4 3.4 0 0 1 .676-.513q.487-.293.846-.654.359-.367.556-.838.203-.476.203-1.088 0-.915-.452-1.565a2.84 2.84 0 0 0-1.247-.988q-.795-.345-1.83-.346Z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/RadioOff.tsx
function SvgRadioOff(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
		})
	});
}
//#endregion
//#region src/RadioOn.tsx
function SvgRadioOn(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
		})]
	});
}
//#endregion
//#region src/RecognizedBadge.tsx
function SvgRecognizedBadge(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.882 5.043 12 2 9.118 5.043l-4.19-.114.115 4.19L2 12l3.043 2.882-.114 4.19 4.19-.115L12 22l2.882-3.043 4.19.114-.115-4.19L22 12l-3.043-2.882.114-4.19zm1.865 4.621a1 1 0 0 0-1.494-1.328l-4.63 5.207-1.916-1.917a1 1 0 0 0-1.414 1.414l2.667 2.667a1 1 0 0 0 1.454-.043z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Refresh.tsx
function SvgRefresh(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M10.662 5.13A7 7 0 0 1 17.745 8h-1.988a1 1 0 1 0 0 2H20a1 1 0 0 0 1-1V4.757a1 1 0 1 0-2 0v1.586a8.999 8.999 0 1 0 1.301 9.134 1 1 0 1 0-1.845-.773 7 7 0 1 1-7.794-9.575Z"
		})
	});
}
//#endregion
//#region src/RewardsOff.tsx
function SvgRewardsOff(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 21q-1.025 0-2.563-.213a16.5 16.5 0 0 1-2.962-.687q-1.425-.476-2.45-1.238T3 17v-2.5q0 1.1 1.025 1.862 1.025.763 2.45 1.238t2.962.687T12 18.5q1.05 0 2.587-.213a15.8 15.8 0 0 0 2.988-.712l1.75 1.75q-1.55.9-3.75 1.287Q13.375 21 12 21m8.775-3.05-1.25-1.25q.675-.425 1.075-.975T21 14.5V17q0 .275-.05.5t-.175.45M12 16q-1.025 0-2.563-.213a16.5 16.5 0 0 1-2.962-.687q-1.425-.476-2.45-1.238T3 12V9.5q0 1.1 1.025 1.862 1.025.763 2.45 1.238t2.962.687T12 13.5q.3 0 .662-.013t.763-.062L15.6 15.6q-1.025.2-1.963.3Q12.7 16 12 16m5.825-1-1.95-1.95a13.8 13.8 0 0 0 3.525-1.275Q21 10.925 21 9.5V12q0 1.05-.913 1.787-.912.738-2.262 1.213m-6.85-4.025q-3.4-.175-5.688-1.3T3 7q0-.65.437-1.238.438-.587 1.238-1.087zm2.775-.05L6.625 3.8q1.126-.375 2.487-.588A19 19 0 0 1 12 3q3.75 0 6.375 1.175T21 7q0 1.449-2.063 2.55-2.062 1.1-5.187 1.375M19.775 22.6 1.4 4.225 2.8 2.8l18.4 18.4z"
		})
	});
}
//#endregion
//#region src/Save.tsx
function SvgSave(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 3a1 1 0 0 1 1 1v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414L12 15.414l-3.707-3.707a1 1 0 1 1 1.414-1.414L11 11.586V4a1 1 0 0 1 1-1M2 9a3 3 0 0 1 3-3h3a1 1 0 0 1 0 2H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-3a1 1 0 1 1 0-2h3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Search.tsx
function SvgSearch(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11 4a7 7 0 1 0 3.594 13.008l3.699 3.7a1 1 0 0 0 1.414-1.415l-3.555-3.555A7 7 0 0 0 11 4m-5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Seed.tsx
function SvgSeed(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 11a6 6 0 0 0-6-6H5a1 1 0 0 0-1 1v1a6 6 0 0 0 6 6v6a1 1 0 1 0 2 0zm1 0a6 6 0 0 1 6-6h1a1 1 0 0 1 1 1v1a6 6 0 0 1-6 6h-1a1 1 0 0 1-1-1z"
		})
	});
}
//#endregion
//#region src/SellTag.tsx
function SvgSellTag(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8.5 7q.624 0 1.063.438Q10 7.875 10 8.5q0 .624-.438 1.063A1.45 1.45 0 0 1 8.5 10q-.624 0-1.063-.438A1.45 1.45 0 0 1 7 8.5q0-.624.438-1.063A1.45 1.45 0 0 1 8.5 7"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.892 3.01a2 2 0 0 1 1.167.56l8.37 8.384.133.147q.184.226.283.494.13.356.13.713l-.007.177q-.026.264-.123.523-.13.345-.416.63l-6.801 6.792-.148.134a1.9 1.9 0 0 1-1.208.436l-.178-.009a1.97 1.97 0 0 1-1.03-.427l-.147-.134-8.395-8.384a1.88 1.88 0 0 1-.548-1.33V4.9q0-.686.43-1.199l.13-.142Q4.093 3.001 4.878 3h6.825zm-6.916 8.66 8.296 8.286 6.67-6.661L11.66 5H4.976z",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/Send.tsx
function SvgSend(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m12.013 21.389-2.664-6.717-6.718-2.664c-.848-.337-.84-1.541.014-1.865l16.018-6.076c.806-.305 1.596.484 1.29 1.29l-6.076 16.018c-.324.854-1.528.863-1.864.014m-3.069-9.03 4.091-2.045a.5.5 0 0 1 .671.67l-2.045 4.092 1.26 3.18 4.374-11.53-11.53 4.373z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Settings.tsx
function SvgSettings(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.07 2c-.635 0-1.184.411-1.316.987l-.132.573c-.194.843-.872 1.508-1.677 1.941-.808.435-1.76.64-2.65.374l-.604-.182c-.604-.182-1.264.053-1.581.562l-.93 1.49c-.317.51-.207 1.155.265 1.55l.53.44c.67.559.948 1.4.948 2.234 0 .867-.285 1.743-.982 2.323l-.496.414c-.472.394-.582 1.04-.265 1.549l.93 1.49c.317.51.977.744 1.581.562l.711-.214c.86-.258 1.781-.064 2.564.354.785.42 1.444 1.069 1.633 1.89l.155.676c.132.576.681.987 1.317.987h1.858c.636 0 1.185-.411 1.317-.987l.155-.676c.19-.821.848-1.47 1.633-1.89.782-.418 1.704-.612 2.563-.354l.712.214c.604.182 1.264-.052 1.581-.562l.93-1.49c.317-.51.207-1.155-.265-1.549l-.497-.414c-.696-.58-.982-1.456-.982-2.323 0-.835.28-1.675.95-2.233l.529-.442c.472-.394.582-1.04.265-1.549l-.93-1.49c-.317-.51-.977-.744-1.581-.562l-.604.182c-.89.267-1.843.061-2.65-.374-.805-.433-1.484-1.098-1.678-1.941l-.131-.573C14.113 2.41 13.565 2 12.929 2zm-3.109 9.969C7.961 9.904 9.77 8 12 8s4.038 1.904 4.038 3.969S14.23 16 12 16s-4.039-1.967-4.039-4.031",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/SidePanel.tsx
function SvgSidePanel(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m13 12-5 4V8z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.614 3c1.324 0 2.4 1.076 2.4 2.4L22 18.652C22 19.977 20.923 21 19.6 21l-15.2-.054c-1.323 0-2.4-1.023-2.4-2.346l.015-13.253c0-1.324 1.075-2.4 2.4-2.4l15.2.053ZM4 18.999h11V5H4zm13 0h3V5h-3z",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/SmX.tsx
function SvgSmX(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5.28 1.92a3.36 3.36 0 0 0-3.36 3.36v13.44a3.36 3.36 0 0 0 3.36 3.36h13.44a3.36 3.36 0 0 0 3.36-3.36V5.28a3.36 3.36 0 0 0-3.36-3.36zm1 4.32h3.81l2.706 3.845L16.08 6.24h1.2l-3.941 4.614 4.86 6.906h-3.81l-3.14-4.46-3.81 4.46h-1.2l4.469-5.23zm1.838.96 6.771 9.6h1.471L9.59 7.2z"
		})
	});
}
//#endregion
//#region src/SortByDefault.tsx
function SvgSortByDefault(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L12 6.414 8.707 9.707a1 1 0 0 1-1.414-1.414zm0 15.414a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L12 17.586l-3.293-3.293a1 1 0 0 0-1.414 1.414z"
		})
	});
}
//#endregion
//#region src/SortByDown.tsx
function SvgSortByDown(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 6a1 1 0 0 0-1 1v9.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L13 16.586V7a1 1 0 0 0-1-1"
		})
	});
}
//#endregion
//#region src/SortByUp.tsx
function SvgSortByUp(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 7.414V17a1 1 0 1 1-2 0V7.414L8.707 9.707a1 1 0 0 1-1.414-1.414z"
		})
	});
}
//#endregion
//#region src/Stake.tsx
function SvgStake(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.707 4.05a7 7 0 1 1 9.9 9.9l-6.115 6.076a7 7 0 0 1-9.829-9.899zm1.414 1.414a5 5 0 0 0-1.114 1.694l.005.012-.011.005a5.001 5.001 0 1 0 1.12-1.71Zm-3.947 4.539.01-.004-.005-.01a5 5 0 0 1 .478-.918 6.98 6.98 0 0 0 2.05 4.879A6.98 6.98 0 0 0 14.585 16a5 5 0 0 1-7.411-5.997M4.829 11.9a5 5 0 0 0 6.928 6.928A7 7 0 0 1 4.83 11.9Z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/StarHex.tsx
function SvgStarHex(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.182 6.399a.2.2 0 0 0-.364 0l-1.453 3.183a.2.2 0 0 1-.16.116l-3.476.398a.2.2 0 0 0-.113.346l2.579 2.366a.2.2 0 0 1 .06.187l-.695 3.43a.2.2 0 0 0 .295.214l3.047-1.721a.2.2 0 0 1 .196 0l3.047 1.72a.2.2 0 0 0 .295-.213l-.696-3.43a.2.2 0 0 1 .061-.187l2.579-2.366a.2.2 0 0 0-.113-.346l-3.477-.398a.2.2 0 0 1-.159-.116z"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13.457 1.666a3 3 0 0 0-2.914 0l-7 3.889A3 3 0 0 0 2 8.177v7.646a3 3 0 0 0 1.543 2.623l7 3.889a3 3 0 0 0 2.914 0l7-3.89A3 3 0 0 0 22 15.824V8.177a3 3 0 0 0-1.543-2.622l-7-3.89Zm-1.943 1.748a1 1 0 0 1 .972 0l7 3.889a1 1 0 0 1 .514.874v7.646a1 1 0 0 1-.514.875l-7 3.888a1 1 0 0 1-.972 0l-7-3.888A1 1 0 0 1 4 15.823V8.177a1 1 0 0 1 .514-.874l7-3.89Z",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/Subnames.tsx
function SvgSubnames(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7 3a2.998 2.998 0 0 1 .984 5.831A1 1 0 0 1 8 9v3a1 1 0 0 0 1 1h7.585l-2.535-2.536a1 1 0 1 1 1.414-1.414l4.95 4.95-4.95 4.95a1 1 0 0 1-1.414-1.415L16.585 15H9a3 3 0 0 1-3-3V9a1 1 0 0 1 .015-.169A2.998 2.998 0 0 1 7 3m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/SwapAccount.tsx
function SvgSwapAccount(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M10.707 4.707a1 1 0 0 0-1.414-1.414L4.301 8.285A1 1 0 0 0 4 9a1 1 0 0 0 .383.787c.17.134.384.213.617.213h14a1 1 0 1 0 0-2H7.414zM4 16a1 1 0 0 1 1-1h14a1 1 0 0 1 .876.518 1 1 0 0 1-.08 1.086 1 1 0 0 1-.097.111l-4.992 4.992a1 1 0 0 1-1.414-1.414L16.586 17H5a1 1 0 0 1-1-1"
		})
	});
}
//#endregion
//#region src/ThumbUp.tsx
function SvgThumbUp(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.476 19h-6.333c-1.5 0-2.714-1.193-2.714-2.664v-5.02c0-1.335.54-2.614 1.5-3.557L15.5 3.5s.514.144 1.138.757q.159.155.26.421.102.267.102.511v.31l-2 3.733h5.19q.724 0 1.267.533T22 11.008v1.776a1.8 1.8 0 0 1-.136.666l-2.714 4.484a1.8 1.8 0 0 1-.679.755 1.8 1.8 0 0 1-.995.31ZM4.81 9.232c.999 0 1.809.795 1.809 1.776v6.216c0 .98-.81 1.776-1.81 1.776C3.81 19 3 18.205 3 17.224v-6.216c0-.981.81-1.776 1.81-1.776"
		})
	});
}
//#endregion
//#region src/Trade.tsx
function SvgTrade(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 23q-2.8 0-5.15-1.275a11.14 11.14 0 0 1-3.85-3.4V20a1 1 0 1 1-2 0v-3.662a1.338 1.338 0 0 1 2.402-.811L4.525 17q1.2 1.8 3.162 2.9Q9.651 21 12 21q1.874 0 3.512-.712a9.2 9.2 0 0 0 2.85-1.925 9.2 9.2 0 0 0 1.926-2.85 8.5 8.5 0 0 0 .66-2.515c.058-.549.5-.998 1.052-.998s1.005.449.957.999a10.5 10.5 0 0 1-.82 3.276 11.1 11.1 0 0 1-2.362 3.5q-1.5 1.5-3.5 2.363A10.7 10.7 0 0 1 12 23m-.9-4v-1.3q-1.174-.274-1.912-1.012C8.45 15.95 8.332 15.55 8.1 14.75l1.65-.65q.3 1.025.938 1.537.637.513 1.462.513.824 0 1.412-.387.588-.388.588-1.213 0-.725-.613-1.175-.612-.45-2.187-1.025-1.475-.525-2.162-1.25-.688-.725-.688-1.9 0-1.025.713-1.862.712-.838 1.937-1.088V5h1.75v1.25q.9.075 1.637.725.738.65 1.013 1.525l-1.6.65a2.2 2.2 0 0 0-.65-.963q-.45-.387-1.25-.387-.875 0-1.338.375-.462.375-.462 1.025t.575 1.025 2.075.875q1.8.65 2.4 1.525t.6 1.925q0 .725-.25 1.275t-.662.938a3.3 3.3 0 0 1-.963.624q-.55.239-1.175.363V19zM2 12c-.552 0-1.005-.449-.957-.999q.149-1.721.82-3.276a11.1 11.1 0 0 1 2.362-3.5q1.5-1.5 3.5-2.362A10.7 10.7 0 0 1 12 1q2.8 0 5.15 1.275t3.85 3.4V4a1 1 0 1 1 2 0v3.662a1.338 1.338 0 0 1-2.401.811L19.475 7q-1.2-1.8-3.163-2.9Q14.351 3 12 3q-1.874 0-3.512.712a9.2 9.2 0 0 0-2.85 1.925 9.2 9.2 0 0 0-1.925 2.85 8.5 8.5 0 0 0-.66 2.515c-.06.549-.5.998-1.053.998",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/TriangleDown.tsx
function SvgTriangleDown(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.35 9c.578 0 .867.681.459 1.08l-4.85 4.735a.66.66 0 0 1-.917 0l-4.85-4.735C6.781 9.68 7.071 9 7.648 9z"
		})
	});
}
//#endregion
//#region src/TriangleLeft.tsx
function SvgTriangleLeft(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14 7.15c0-.578-.681-.867-1.08-.459l-4.735 4.85a.66.66 0 0 0 0 .917l4.735 4.85c.399.41 1.08.12 1.08-.457z"
		})
	});
}
//#endregion
//#region src/TriangleRight.tsx
function SvgTriangleRight(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M10 7.15c0-.578.681-.867 1.08-.459l4.735 4.85a.66.66 0 0 1 0 .917l-4.735 4.85c-.399.41-1.08.12-1.08-.457z"
		})
	});
}
//#endregion
//#region src/TriangleUp.tsx
function SvgTriangleUp(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7.65 15c-.578 0-.867-.681-.459-1.08l4.85-4.735a.66.66 0 0 1 .917 0l4.85 4.735c.41.399.12 1.08-.457 1.08z"
		})
	});
}
//#endregion
//#region src/Unpined.tsx
function SvgUnpined(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17 3v2h-1v8.175L7.825 5 7 4.175V3zm-5 20-1-1v-6H6v-2l2-2v-1.15L1.4 4.2l1.4-1.4 18.4 18.4-1.45 1.4-6.6-6.6H13v6z"
		})
	});
}
//#endregion
//#region src/Unstake.tsx
function SvgUnstake(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m19.607 13.95-1.464 1.455-1.747-1.716a5 5 0 1 0-6.39-6.53l.006.011-.011.005-.063.168-1.773-1.742 1.542-1.55a7 7 0 1 1 9.9 9.899"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.663 10.127 4.675 9.11l2.185 2.15a5 5 0 0 0 5.624 5.526l2.146 2.109-1.14 1.132a7 7 0 0 1-9.828-9.899ZM4.83 11.9a5 5 0 0 0 6.928 6.928A7 7 0 0 1 4.83 11.9",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.086 21.414 2 4.414 3.414 3 20.5 20z"
			})
		]
	});
}
//#endregion
//#region src/Usdto.tsx
function SvgUsdto(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.077 23H9.923v-4.308h4.154zm-4.154-4.308H5.77v-8.077h4.154zm8.307 0h-4.153v-8.077h4.154v8.077ZM21 6.308h-6.923v4.307H9.923V6.308H3V2h18z"
		})
	});
}
//#endregion
//#region src/Vest.tsx
function SvgVest(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.708 6.293a3 3 0 1 0-1.414 1.414l1.534 1.536a5 5 0 0 0 6.929 6.929l1.535 1.535a3 3 0 1 0 1.414-1.414l-1.534-1.536a5 5 0 0 0-6.929-6.929zM4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m7 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M19 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4M7 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
		})]
	});
}
//#endregion
//#region src/Vesting.tsx
function SvgVesting(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsxs("g", {
			fill: "currentColor",
			clipPath: "url(#vesting_svg__a)",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v6a1 1 0 1 1-2 0V8H5v9a1 1 0 0 0 1 1h4a1 1 0 1 1 0 2H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1" }),
				/* @__PURE__ */ jsx("path", { d: "M8 10a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z" }),
				/* @__PURE__ */ jsx("path", {
					fillRule: "evenodd",
					d: "M18 22.465a4 4 0 1 1 0-6.929 4 4 0 1 1 0 6.929m1.5-1.528a2.002 2.002 0 0 0 2.483-1.676 2 2 0 0 0-2.482-2.198c.318.574.499 1.234.499 1.937s-.181 1.363-.5 1.937",
					clipRule: "evenodd"
				})
			]
		}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
			id: "vesting_svg__a",
			children: /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				d: "M0 0h24v24H0z"
			})
		}) })]
	});
}
//#endregion
//#region src/VisibilityOff.tsx
function SvgVisibilityOff(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18.72 6.695a1 1 0 1 0-1.44-1.39l-1.518 1.572C14.601 6.348 13.331 6 12 6 8.739 6 5.843 8.092 4.017 9.805c-1.29 1.212-1.29 3.178 0 4.39a18 18 0 0 0 2.666 2.083l-1.695 1.755a1 1 0 0 0 1.438 1.39zM8.67 14.219l5.431-5.623a4 4 0 0 0-5.43 5.623Z",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M16 12a4 4 0 0 1-3.975 4l-1.749 1.81c.56.122 1.136.19 1.724.19 3.26 0 6.157-2.092 7.983-3.805 1.29-1.212 1.29-3.178 0-4.39a20 20 0 0 0-1.071-.936l-2.914 3.017z"
		})]
	});
}
//#endregion
//#region src/VisibilityOn.tsx
function SvgVisibilityOn(props) {
	return /* @__PURE__ */ jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: [/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
		}), /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.983 9.805c1.29 1.212 1.29 3.178 0 4.39C18.157 15.908 15.26 18 12 18c-3.261 0-6.157-2.092-7.983-3.805-1.29-1.212-1.29-3.178 0-4.39C5.843 8.092 8.74 6 12 6s6.157 2.092 7.983 3.805M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
			clipRule: "evenodd"
		})]
	});
}
//#endregion
//#region src/Wallet.tsx
function SvgWallet(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3.175 18.825Q4.35 20 6 20h12q1.65 0 2.825-1.175T22 16V8q0-1.65-1.175-2.825T18 4H6Q4.35 4 3.175 5.175T2 8v8q0 1.65 1.175 2.825M18 8H6q-.55 0-1.05.125a3.4 3.4 0 0 0-.95.4V8q0-.824.588-1.412A1.93 1.93 0 0 1 6 6h12q.824 0 1.413.588Q20 7.175 20 8v.525a3.4 3.4 0 0 0-.95-.4A4.3 4.3 0 0 0 18 8m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
			clipRule: "evenodd"
		})
	});
}
//#endregion
//#region src/Warning.tsx
function SvgWarning(props) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13.732 3c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.732-3zM12 17.8a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m-1.2-9.6a1.2 1.2 0 0 1 2.4 0v3.6a1.2 1.2 0 0 1-2.4 0z",
			clipRule: "evenodd"
		})
	});
}
//#endregion
export { SvgActivity as Activity, SvgAdd as Add, SvgApps as Apps, SvgArrowBack as ArrowBack, SvgArrowBottomLeft as ArrowBottomLeft, SvgArrowDown as ArrowDown, SvgArrowForward as ArrowForward, SvgArrowLeft as ArrowLeft, SvgArrowRight as ArrowRight, SvgArrowTopRight as ArrowTopRight, SvgArrowUp as ArrowUp, SvgAssets as Assets, SvgCalendar as Calendar, SvgCheckmark as Checkmark, SvgCheckmarkFilled as CheckmarkFilled, SvgCircleEmitter as CircleEmitter, SvgClock as Clock, SvgClose as Close, SvgCloseFilled as CloseFilled, SvgCoin as Coin, SvgCopy as Copy, SvgCreate as Create, SvgDarkMode as DarkMode, SvgDash as Dash, SvgDataStack as DataStack, SvgDelete as Delete, SvgDisconnect as Disconnect, SvgDiscord as Discord, SvgDoubleArrowLeft as DoubleArrowLeft, SvgDoubleArrowRight as DoubleArrowRight, SvgEdit as Edit, SvgExclamation as Exclamation, SvgExpand as Expand, SvgExport as Export, SvgFilterList as FilterList, SvgFirefly as Firefly, SvgFlag as Flag, SvgGasStation as GasStation, SvgGlobe as Globe, SvgHandler as Handler, SvgHome as Home, SvgImageIcon as ImageIcon, SvgImportPass as ImportPass, SvgInfo as Info, SvgIotaLogoMark as IotaLogoMark, SvgIotaLogoSmall as IotaLogoSmall, SvgIotaLogoWeb as IotaLogoWeb, SvgKey as Key, SvgKeystone as Keystone, SvgLedger as Ledger, SvgLightMode as LightMode, SvgLink as Link, SvgListViewLarge as ListViewLarge, SvgListViewMedium as ListViewMedium, SvgListViewSmall as ListViewSmall, SvgLoader as Loader, SvgLoader2 as Loader2, SvgLockLocked as LockLocked, SvgLockUnlocked as LockUnlocked, SvgLogout as Logout, SvgMail as Mail, SvgMenuIcon as MenuIcon, SvgMigration as Migration, SvgMoreHoriz as MoreHoriz, SvgMoreVert as MoreVert, SvgNotifications as Notifications, SvgOutboundLink as OutboundLink, SvgPasskey as Passkey, SvgPause as Pause, SvgPercentDiscount as PercentDiscount, SvgPerson as Person, SvgPined as Pined, SvgPlaceholderReplace as PlaceholderReplace, SvgPlay as Play, SvgProfile as Profile, SvgQrCode as QrCode, SvgQuestionMarkFilled as QuestionMarkFilled, SvgRadioOff as RadioOff, SvgRadioOn as RadioOn, SvgRecognizedBadge as RecognizedBadge, SvgRefresh as Refresh, SvgRewardsOff as RewardsOff, SvgSave as Save, SvgSearch as Search, SvgSeed as Seed, SvgSellTag as SellTag, SvgSend as Send, SvgSettings as Settings, SvgSidePanel as SidePanel, SvgSmX as SmX, SvgSortByDefault as SortByDefault, SvgSortByDown as SortByDown, SvgSortByUp as SortByUp, SvgStake as Stake, SvgStarHex as StarHex, SvgSubnames as Subnames, SvgSwapAccount as SwapAccount, SvgThumbUp as ThumbUp, SvgTrade as Trade, SvgTriangleDown as TriangleDown, SvgTriangleLeft as TriangleLeft, SvgTriangleRight as TriangleRight, SvgTriangleUp as TriangleUp, SvgUnpined as Unpined, SvgUnstake as Unstake, SvgUsdto as Usdto, SvgVest as Vest, SvgVesting as Vesting, SvgVisibilityOff as VisibilityOff, SvgVisibilityOn as VisibilityOn, SvgWallet as Wallet, SvgWarning as Warning };
